/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * 
 */
export type TransactionStatusEnum = 1 | 2 | 3;

export const TransactionStatusEnum = {
    NUMBER_1: 1 as TransactionStatusEnum,
    NUMBER_2: 2 as TransactionStatusEnum,
    NUMBER_3: 3 as TransactionStatusEnum
};
